import { rateSheetLineHeaders } from '@/headers/RateSheet'
import * as rateSheetActions from '@/store/modules/rate-sheet/actions'
import i18n from '@/i18n'
import { getMargin, activityPeriodRange } from '@/utils/pdf-formatters/pdfHelpers'
import { formatMoney } from '@/utils/NumericMutations'
import { rateSheetDefinitionLineSorter } from '@/components/account/account-scaling/rate-sheet-definitions/RateSheetDefinitions.js'

const NO_CONTEXT = undefined

export const fetchRateSheetById = async (rateSheetId) => {
  const result = await rateSheetActions.default.fetchRateSheet(NO_CONTEXT, rateSheetId)
  result.rateSheetLines.sort(rateSheetDefinitionLineSorter)
  return {
    ...result,
    rateSheetLines: result.rateSheetLines.map(line => ({
      ...line,
      speciesGroup: line.speciesGroup?.label,
      lengthGroup: line.lengthGroup?.label,
      diameterGroup: line.diameterGroup?.label,
      grade: line.grade?.name,
      endUseSort: line.endUseSort?.name
    }))
  }
}

const defaultRateSheetLayout = {
  fillColor: function (rowIndex) {
    return (rowIndex % 2 === 0) ? 'white' : 'lightgrey'
  },
  vLineWidth: function (i) {
    return 0
  },
  hLineWidth: function (i) {
    if (i === 1) {
      return 1
    } else {
      return 0
    }
  }
}

export function rateSheetTableBlock (rateSheet, margin = {}, layout = defaultRateSheetLayout) {
  return {
    margin: getMargin(margin),
    layout,
    table: getRateSheetTable(rateSheet)
  }
}

export async function getRateSheetPage ({ rateSheetId, activityName }, activityPeriod) {
  const rateSheet = await fetchRateSheetById(rateSheetId)
  return [{
    pageBreak: 'before',
    text: `${activityName}: ${rateSheet.name}`,
    style: 'title'
  },
  ...(activityPeriod
    ? [{
      text: `${i18n.t('effective')} ${activityPeriod.timezone ? `(${activityPeriod.timezone})` : ''}: ${activityPeriodRange(activityPeriod)}`,
      style: 'subtitle',
      margin: getMargin({ top: 2 })
    }]
    : []),
  rateSheetTableBlock(rateSheet, { top: 16 })]
}

function getRateSheetTable (rateSheet) {
  const headers = rateSheetLineHeaders(false).getColumns().filter(c => c.text.length > 0)
  const headersFiltered = getHeadersForWhichDataExists(rateSheet, headers)
  return {
    widths: headersFiltered.map(() => '*'),
    headerRows: 1,
    body: getRateSheetTableBody(rateSheet, headersFiltered)
  }
}

function getHeadersForWhichDataExists (rateSheet, headers) {
  return headers.filter(h => {
    return rateSheet.rateSheetLines.some(line => line[h.value] != null)
  })
}

function getRateSheetTableBody (rateSheet, headers) {
  const tableBody = []
  const headerRow = headers.map(h => ({ text: h.text, style: 'header', alignment: h.align }))
  tableBody.push(headerRow)

  const bodyRows = rateSheet.rateSheetLines.map(line => {
    return headers.map(h => {
      const cellValue = h.value === 'rate' ? formatMoney(line[h.value]) : line[h.value] || ''
      return { text: cellValue, style: 'subtitle', alignment: h.align }
    })
  })

  tableBody.push(...bodyRows)
  return tableBody
}
